export const SET_POSTNUM = 'SET_POSTNUM'